import { render, staticRenderFns } from "./Reset-Password-Link.vue?vue&type=template&id=bcfbfc06&scoped=true&"
import script from "./Reset-Password-Link.vue?vue&type=script&lang=js&"
export * from "./Reset-Password-Link.vue?vue&type=script&lang=js&"
import style0 from "./Reset-Password-Link.vue?vue&type=style&index=0&id=bcfbfc06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfbfc06",
  null
  
)

export default component.exports